import { z } from 'zod'

/** Nullable range bounds shared by admin filter forms (RHF + Zod). */
export const dateRangeBoundsSchema = z.object({
  from: z.date().nullable(),
  to: z.date().nullable(),
})

export type DateRangeBounds = z.infer<typeof dateRangeBoundsSchema>
